import { render, staticRenderFns } from "./ReservierungBestellung.vue?vue&type=template&id=a6aa6a2c"
import script from "./ReservierungBestellung.vue?vue&type=script&lang=ts"
export * from "./ReservierungBestellung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports